import { NODE_ENV, REACT_APP__ENVIRONMENT } from "./env";
export const testAppendAttr = (type, value) => NODE_ENV === "development" ||
    REACT_APP__ENVIRONMENT === "staging" ||
    REACT_APP__ENVIRONMENT === "dev"
    ? {
        [`data-test-${type}`]: value,
    }
    : {};
//# sourceMappingURL=test.js.map